/**
 * 全局常量配置
 * 资源文件地址、接口地址等统一在此管理，修改时只需改这里
 *
 * 运行时注入：线上打包时 build.js 会从 server/.env 读 APP_API_BASE / APP_API_AUTH / APP_CDN_BASE
 * 生成 config.js（window.__APP_CONFIG__）覆盖进二进制；未注入时回退到下面的默认值。
 * 默认相对路径 = 跟当前域名走（本地 devServer proxy / 线上网关反代），无需改代码。
 */
const RTC = window.__APP_CONFIG__ || {}

// 后台服务 API 接口前缀（配了绝对地址则前端直连该域名，实现前后端分离）
export const API_LOGIN = RTC.API_AUTH || ''
export const API_BASE = RTC.API_BASE || '/buyagent'

// 客户端标识
export const CLIENT_ID = 'e5cd7e4891bf95d1d19206ce24a7b32e'

// 租户ID
export const TENANT_ID = '000000'

// Token 存储 key
export const TOKEN_KEY = 'access_token'

// MinIO 资源文件访问前缀
export const CDN_BASE = RTC.CDN_BASE || 'https://www.qydxwl.com'

// 常用接口路径快捷引用
export const API = {
  /** 账号密码登录 */
  LOGIN: `${API_LOGIN}/auth/login`,
  /** 获取验证码 */
  CODE: `${API_LOGIN}/auth/code`,
  /** 获取租户列表 */
  TENANT_LIST: `${API_LOGIN}/auth/tenant/list`,
  /** 登出 */
  LOGOUT: `${API_LOGIN}/auth/logout`,

  // ── 积分商品 ──
  /** 积分商品列表 */
  POINT_PRODUCT_LIST: `${API_BASE}/pointProduct/list`,
  /** 新增积分商品 */
  POINT_PRODUCT_ADD: `${API_BASE}/pointProduct/add`,
  /** 修改积分商品 */
  POINT_PRODUCT_EDIT: `${API_BASE}/pointProduct/edit`,
  /** 删除积分商品 */
  POINT_PRODUCT_REMOVE: `${API_BASE}/pointProduct/remove`,
  /** 商品图片上传（走 devServer proxy 到独立文件服务） */
  FILE_UPLOAD: '/fileService/v1/file/upload',
}
